<div id="resume-container" class="d-block bg-dark text-white text-center pt-4 pb-4 pe-3 ps-3">
  <button *ngIf="turn==null" class="btn btn-hamb float-end" type="button" data-bs-toggle="collapse"
    data-bs-target="#collapseNoTurn" aria-expanded="false" aria-controls="collapseNoTurn">
    <i aria-hidden="true" class="fa fa-bars"></i>
  </button>

  <div class="collapse" [ngClass]="{'show': turn!=null}" id="collapseNoTurn">
    <div class="ticket-content p-3 bg-dark text-ligth animated flash" *ngIf="turn!=null&&enableTurnInformation">
      <h1>{{ turn["label"] }}</h1>
      <h4>
        {{ turn["prekindname"] }}
        <button (click)="openAtypesModal()" class="btn btn-light btn-sm ms-2" [title]="'changeAtype' | language ">
          <i class="fa fa-exchange" aria-hidden="true"></i>
        </button>
      </h4>

      <div class="btn-group btn-group-sm mb-2 mt-1 turn-options" role="group" aria-label="Basic example">
        <button (click)="history.openHistoryModal(turn, 'informationHistory')" type="button"
          class="btn btn-light">{{ "historyTurn" | language }}</button>
        <button (click)="openClientData()" type="button" class="btn btn-light">{{ "clientData" | language }}</button>
        <button *ngIf="turn['rdcomment']" (click)="showObservation = !showObservation" type="button"
          class="btn btn-warning">{{ "viewObservations" | language }}</button>
      </div>
      <br>
      <span class="text-warning"><strong>{{ turn["clientname"] }}</strong></span><br>
      <ng-container *ngIf="showObservation && turn['rdcomment'
      ]"><span>{{ "observations" | language }}:</span> <span class="text-warning" [innerHTML]="turn['rdcomment']"></span>
      </ng-container>
      <p class="text-start pt-3 mt-3 mb-0">
        <i class="fa fa-hourglass-end" aria-hidden="true"></i> {{ "inWait" | language }}:
        <strong>{{ turn["twaiting"] }}</strong><br>
        <i class="fa fa-clock-o" aria-hidden="true"></i> {{ "inAttention" | language }}:
        <strong>{{ counter }}</strong><br>
        <span *ngIf="turn['maxtime'] != 0 && maxTimeExceded == 0"
          class="badge text-bg-light mt-2">{{ "maxTime" | language }}: {{ turn["maxtime"] }} min</span>
        <span *ngIf="turn['maxtime'] != 0 && maxTimeExceded == 1" class="badge text-bg-warning mt-2"><i
            class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ "maxTime" | language }}: {{ turn["maxtime"] }}
          min</span>
        <span *ngIf="turn['maxtime'] != 0 && maxTimeExceded == 2"
          class="badge text-bg-danger animated flash infinite mt-2"><i class="fa fa-exclamation-triangle"
            aria-hidden="true"></i> {{ "maxTime" | language }}: {{ turn["maxtime"] }} min</span>
      </p>
      <div *ngIf="_data.configuration['showCcodeInput']" class="container-code input-group mt-3 pt-2">
        <div id="clientid-title">{{ "clientCode" | language }}:</div>
        <input type="text" class="form-control" [(ngModel)]="ccode">
        <div class="input-group-text">
          <button *ngIf="saveCcode == 0" class="btn btn-outline-light" type="submit" (click)="changeCcode()">
            OK
          </button>
          <button *ngIf="saveCcode == 1" class="btn btn-outline-light" type="submit">
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </button>
          <button *ngIf="saveCcode == 2" class="btn btn-success" type="submit">
            <i class="fa fa-check"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="ticket-content p-3 bg-dark text-ligth inline-block" *ngIf="turn==null">
      <h2 class="no-turn"><i class="fa fa-user-times" aria-hidden="true"></i><br>{{ "noTurn" | language }}</h2>
    </div>
    <div class="ticket-content p-3 bg-dark text-light" *ngIf="_data.configuration['showViewerInfo']">
      <h5>{{ "lastViewerCalls" | language }}</h5>
      <div class="viewer-call-content">
        <table class="table table-bordered viewer-cell mb-3" *ngFor="let viewer of viewers">
          <thead>
            <tr>
              <th colspan="4">{{ viewer.name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="0" rowspan="0" class="pt-2">
                <h2 *ngIf="_data.lastCalls[0]"
                  [ngClass]="{'text-danger': getTurnStatus(viewer.id, _data.lastCalls[0]) == 'error', 'text-success': getTurnStatus(viewer.id, _data.lastCalls[0]) == 'success'}">

                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[0]) == 'error'" class="fa fa-times"
                    aria-hidden="true"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[0]) == 'loading'"
                    class="fa fa-spinner fa-pulse fa-fw"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[0]) == 'success'" class="fa fa-check"
                    aria-hidden="true"></i>
                  {{ _data.lastCalls[0].label }}
                </h2>
                <h2 *ngIf="!_data.lastCalls[0]">--</h2>
              </td>
              <td>
                <span *ngIf="_data.lastCalls[1]"
                  [ngClass]="{'text-danger': getTurnStatus(viewer.id, _data.lastCalls[1]) == 'error', 'text-success': getTurnStatus(viewer.id, _data.lastCalls[1]) == 'success'}">
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[1]) == 'error'" class="fa fa-times"
                    aria-hidden="true"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[1]) == 'loading'"
                    class="fa fa-spinner fa-pulse fa-fw"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[1]) == 'success'" class="fa fa-check"
                    aria-hidden="true"></i>
                  {{ _data.lastCalls[1].label }}
                </span>
                <span *ngIf="!_data.lastCalls[1]">--</span>
              </td>
              <td>
                <span *ngIf="_data.lastCalls[2]"
                  [ngClass]="{'text-danger': getTurnStatus(viewer.id, _data.lastCalls[2]) == 'error', 'text-success': getTurnStatus(viewer.id, _data.lastCalls[2]) == 'success'}">
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[2]) == 'error'" class="fa fa-times"
                    aria-hidden="true"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[2]) == 'loading'"
                    class="fa fa-spinner fa-pulse fa-fw"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[2]) == 'success'" class="fa fa-check"
                    aria-hidden="true"></i>
                  {{ _data.lastCalls[2].label }}
                </span>
                <span *ngIf="!_data.lastCalls[2]">--</span>
              </td>
            </tr>
            <tr>
              <td>
                <span *ngIf="_data.lastCalls[3]"
                  [ngClass]="{'text-danger': getTurnStatus(viewer.id, _data.lastCalls[3]) == 'error', 'text-success': getTurnStatus(viewer.id, _data.lastCalls[3]) == 'success'}">
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[3]) == 'error'" class="fa fa-times"
                    aria-hidden="true"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[3]) == 'loading'"
                    class="fa fa-spinner fa-pulse fa-fw"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[3]) == 'success'" class="fa fa-check"
                    aria-hidden="true"></i>
                  {{ _data.lastCalls[3].label }}
                </span>
                <span *ngIf="!_data.lastCalls[3]">--</span>
              </td>
              <td>
                <span *ngIf="_data.lastCalls[4]"
                  [ngClass]="{'text-danger': getTurnStatus(viewer.id, _data.lastCalls[4]) == 'error', 'text-success': getTurnStatus(viewer.id, _data.lastCalls[4]) == 'success'}">
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[4]) == 'error'" class="fa fa-times"
                    aria-hidden="true"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[4]) == 'loading'"
                    class="fa fa-spinner fa-pulse fa-fw"></i>
                  <i *ngIf="getTurnStatus(viewer.id, _data.lastCalls[4]) == 'success'" class="fa fa-check"
                    aria-hidden="true"></i>
                  {{ _data.lastCalls[4].label }}
                </span>
                <span *ngIf="!_data.lastCalls[4]">--</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ticket-content p-3 bg-dark text-ligth" *ngIf="_data.configuration['showAllCallsViewer']">
      <h5>{{ "allCallsViewer" | language }} <i (click)="getAllCalls()" class="fa fa-refresh float-right"></i></h5>
      <div class="viewer-call-content">
        <table class="table table-bordered viewer-cell mb-3">
          <tbody>
            <tr *ngFor="let c of allCalls">
              <th>{{ c.label }}</th>
              <td>{{ c.deskname }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

</div>
<app-kindsmodal [id]="'atypesModal'"></app-kindsmodal>
<app-history [id]="'informationHistory'"></app-history>

<app-modal [id]="'clientDataModal'">
  <span modal-title>{{ "clientData" | language }}</span>
  <div modal-body>
    <div *ngIf="clientDataAlert" class="alert alert-success">{{ "dataUpdated" | language }}</div>
    <div class="mb-3">
      <label for="client-name">{{ "clientName" | language }}</label>
      <input type="text" [(ngModel)]="clientName" class="form-control" id="client-name">
    </div>

    <div class="mb-3">
      <label for="client-dni">{{ data.dniTranslation }}</label>
      <input type="text" [(ngModel)]="clientDNI" class="form-control" id="client-dni">
    </div>

    <div class="mb-3">
      <label for="client-observations">{{ "observations" | language }}</label>
      <textarea type="text" [(ngModel)]="clientObservations" class="form-control" id="client-observations"></textarea>
    </div>

    <button (click)="saveClientData()" class="btn btn-success float-end">{{ "save" | language }}</button>
  </div>
</app-modal>
